import { render, staticRenderFns } from "./AlbumView.vue?vue&type=template&id=3e926e4d&"
import script from "./AlbumView.vue?vue&type=script&lang=js&"
export * from "./AlbumView.vue?vue&type=script&lang=js&"
import style0 from "./AlbumView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports